import React, { useCallback } from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '@commonComponents/formComponents/CustomInputField'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import DeleteIcon from '@commonComponents/deleteIcon'
import { useSelector } from 'react-redux'
import { confirmAlert } from 'react-confirm-alert'

const paymentDetailForm = ({dataSource: {id,paymentType,eoriNo,name,role,roleId},translate,paymentTypeList,paymentRoleList,onBlur,onChange,onSelect,deleteData,validateErrors,tableName,title,currentIndex,validatePaymentType}) => {
  const onChangeHandler=useCallback(({target:{value,name}})=>onChange(id,tableName,{[name]:value}),[tableName,id,onChange])
  const isDuties=paymentType=="DUTIES" ? true : null
  const onDropDownChange=useCallback((e, {value,name})=>{
    if(name=="paymentType" && value=="DUTIES" && validatePaymentType && validatePaymentType(value)){
      confirmAlert({
        message:`Only 1 of type ${value} is allowed`,
        buttons: [{label: 'OK'}]
      });
      return
    }
    onSelect(id,tableName,{[name]:value,id,roleId})
    validateErrors()
  },[tableName,id,onSelect,roleId,validateErrors,validatePaymentType])
  
  const onBlurHandler=useCallback(({target:{value,name}})=>{
    onBlur(tableName,{[name]:value,id,roleId})
    validateErrors()
  },[tableName,id,onBlur,roleId,validateErrors])
   
  const typeError=useSelector(state=>state.ValidationErrors.headerTab?.[`${title}${currentIndex+1}_paymentType`]?.msg)
  const idError=useSelector(state=>state.ValidationErrors.headerTab?.[`${title}${currentIndex+1}_eoriNo`]?.msg)
  const roleError=useSelector(state=>state.ValidationErrors.headerTab?.[`${title}${currentIndex+1}_role`]?.msg)
  return (
    <div  className="formContainer">   
   <Grid.Row>
      <Grid.Column>
        <DropDown
          id={`paymentType${id}`}
          label="PAYMENT TYPE"
          name="paymentType"
          labelClass="text-none"
          data={paymentTypeList} 
          onChange={onDropDownChange}
          value={paymentType}
          text={paymentType}
          errors={typeError}
          isDisabled={isDuties}
          />
      </Grid.Column>
      <Grid.Column>
         <InputField
          id={`identification${id}`}
          type="text"
          name="eoriNo"
          label={translate("IDENTIFICATION", {ns:["default", "parties"]})}
          clearInput={false}    
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
          value={eoriNo}
          errors={idError}
          isDisabled={isDuties}
        /> 
      </Grid.Column>
      <Grid.Column>
         <InputField
          id={`paymentName${id}`}
          name="name"
          type="text"
          label={translate("NAME", {ns:["default", "parties"]})}
          clearInput={false}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
          value={name}
          isDisabled={isDuties}
        /> 
      </Grid.Column>
      
      <Grid.Column>
        <DropDown
           id={`type${id}`}
          label={`${translate("TYPE", {ns:["default", "parties"]})}/${translate("ROLE", {ns:["default", "parties"]})}`}
          name="role"
          labelClass="text-none"
          data={paymentRoleList}
          onChange={onDropDownChange}  
          value={role}
          text={role}
          errors={roleError}
          isDisabled={isDuties}
        />
      </Grid.Column>
    </Grid.Row>
    <div className="actionbtns">
       <DeleteIcon onClick={async()=>{
        const resp=await deleteData(id,tableName,{},isDuties)
        validateErrors()
       }
      } />
    </div>
    </div>
  )
}

export default React.memo(paymentDetailForm)
